// extracted by mini-css-extract-plugin
module.exports = {"gridContainer":"HotServices_gridContainer__SwPSn","row":"HotServices_row__i_jPb","col":"HotServices_col__CCOps","link":"HotServices_link__zih_Q","title":"HotServices_title__cCTcd"};